<template>
  <div class="screen-wrapper">
    <div ref="screenRef" class="screen-container" @click="handleOutsideClick">
      <!-- 加载动画 -->
      <div v-if="isLoading" class="loading">
        <div class="loadbox">
          <img src="@/assets/images/loading.gif" />
          页面加载中...
        </div>
      </div>

      <!-- 电子商城浮层 -->
      <div v-if="showMall" class="mall-overlay">
        <div class="mall-window" @click.stop>
          <div class="mall-header">
            <!-- <span>电子商城</span>   -->
            <span class="close-btn" @click="showMall = false">✕ 关闭</span>
          </div>

          <iframe src="http://km6.366kmpf.com/youq" class="mall-frame"></iframe>
        </div>
      </div>

      <!-- 顶部标题 -->
      <div class="head"><h1>黄梅水产供应链服务平台</h1></div>

      <!-- 主体内容 -->
      <div class="main-content">
        <!-- 左列 25% -->
        <div class="column-left" @click.stop>
          <IndustryOverview />
          <DemoBase :activeComp="activeComp" @switchCenter="toggleCenter('BaseDetail')" />
          <ECommerce @openWebMall="showMall = true" />
          <UnifiedMarket :activeComp="activeComp" @switchCenter="toggleCenter('MarketDetail')" />
        </div>

        <!-- 中列 50% -->
        <div class="column-center" @click.stop>
          <div class="center-main">
            <transition name="fade-scale" mode="out-in">
              <keep-alive include="CenterMap">
                <component :is="activeComp" @goBack="activeComp = 'CenterMap'" />
              </keep-alive>
            </transition>
          </div>

          <!-- <CenterMap /> -->

          <div class="center-bottom-row">
            <Delivery />
            <SupplyFinance />
          </div>
        </div>

        <!-- 右列 25% -->
        <div class="column-right" @click.stop>
          <PriceTrend :activeComp="activeComp" @switchCenter="toggleCenter('PriceDetail')" />
          <TraceManage />
          <FarmerCollect />
          <BrandManage />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseDetail from '@/components/BaseDetail.vue'
import BrandManage from '@/components/BrandManage.vue'
import CenterMap from '@/components/CenterMap.vue'
import Delivery from '@/components/Delivery.vue'
import DemoBase from '@/components/DemoBase.vue'
import ECommerce from '@/components/ECommerce.vue'
import EcommerceDetail from '@/components/EcommerceDetail.vue'
import FarmerCollect from '@/components/FarmerCollect.vue'
import IndustryOverview from '@/components/IndustryOverview.vue'
import MarketDetail from '@/components/MarketDetail.vue'
import PriceDetail from '@/components/PriceDetail.vue'
import PriceTrend from '@/components/PriceTrend.vue'
import SupplyFinance from '@/components/SupplyFinance.vue'
import TraceManage from '@/components/TraceManage.vue'
import UnifiedMarket from '@/components/UnifiedMarket.vue'

export default {
  name: 'DashboardView',
  components: {
    IndustryOverview,
    DemoBase,
    ECommerce,
    CenterMap,
    UnifiedMarket,
    Delivery,
    SupplyFinance,
    BrandManage,
    PriceTrend,
    TraceManage,
    FarmerCollect,
    MarketDetail,
    EcommerceDetail,
    BaseDetail,
    PriceDetail
  },
  data() {
    return {
      activeComp: 'CenterMap', // 控制中间区域显示的变量
      isLoading: true,
      showMall: false
    }
  },

  mounted() {
    setTimeout(() => {
      this.isLoading = false
    }, 1500)

    // 页面加载完成后初始化缩放
    this.updateScale()
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateScale)
  },

  beforeDestroy() {
    //销毁前移除监听，防止内存泄漏
    window.removeEventListener('resize', this.updateScale)
  },

  methods: {
    updateScale() {
      const screenRef = this.$refs.screenRef
      if (!screenRef) return

      const designWidth = 1920
      const designHeight = 1080

      // 获取当前窗口宽高
      const clientWidth = document.documentElement.clientWidth
      const clientHeight = document.documentElement.clientHeight

      // 计算缩放比例
      const scaleX = clientWidth / designWidth
      const scaleY = clientHeight / designHeight

      screenRef.style.transform = `scale(${scaleX}, ${scaleY}) translate(0, 0)`
    },

    // 点击按钮切换中心视图
    toggleCenter(comp) {
      if (this.activeComp === comp) {
        this.activeComp = 'CenterMap'
      } else {
        this.activeComp = comp
      }
    },

    // 点击中心视图外部区域，返回到 map
    handleOutsideClick() {
      if (this.activeComp !== 'CenterMap') {
        this.activeComp = 'CenterMap'
      }
    }
  }
}
</script>

<style>
@import '@/assets/css/global.css';

.mall-overlay {
  position: fixed;
  width: 1920px;
  height: 1080px;

  display: flex;
  justify-content: center;
  align-items: center;

  /* background: rgba(0, 0, 0, 0.4); */
  z-index: 9999;
}

.mall-window {
  width: 800px;
  height: 600px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.mall-header {
  height: 40px;
  background: #0b1c2c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 15px;
}

.close-btn {
  cursor: pointer;
}

.mall-frame {
  width: 100%;
  height: calc(100% - 40px);
  border: none;
}
</style>
